import { Box, Button, TextField, Typography } from "@mui/material";
import { useCallback, useState } from "react";

interface Props {
  index: number;
  data: any;
  onUpdate: any;
}
const OrderTypeWayPayment: React.FC<Props> = ({ index, data, onUpdate }) => {
  const [state, setState] = useState(data);
  const [btnDisable, setBtnDisable] = useState(true);

  const handleUpdateField = (field: any, value: any) => {
    setBtnDisable(false);
    // console.log({ field, value });
    setState((prev: any) => ({ ...prev, [field]: value }));
    // onUpdate({ ...state, [field]: value });
  };

  // console.log(state[`key${index}`] , state[`value${index}`]);

  const handleSavePayment = () => {
    onUpdate(state);
    setBtnDisable(true);
  }

  return (
    <Box style={{ marginLeft: "20px", marginBottom: "10px" }}>
      {/* <Typography fontSize={"16px"}>Payment {index + 1}</Typography> */}
      <Box display={"flex"} gap={1}>
        <TextField
          type="text"
          placeholder="tender payment name"
          defaultValue={state[`key${index}`]}
          onChange={(e) => handleUpdateField(`key${index}`, e.target.value)}
          size="small"
        />
        <TextField
          type="text"
          placeholder="tender payment ID"
          defaultValue={state[`value${index}`]}
          onChange={(e) => handleUpdateField(`value${index}`, e.target.value)}
          size="small"
        />
        <Button
          variant="outlined"
          disabled={btnDisable}
          onClick={handleSavePayment}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default OrderTypeWayPayment;
